module.exports = __webpack_public_path__ + "static/media/PlayerCutOut.d96b64db.png";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/PlayerCutOut.png
// module id = 7492
// module chunks = 0